import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('ErrorBoundary caught an error:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen flex items-center justify-center bg-gray-50">
          <div className="text-center p-8">
            <h1 className="text-2xl font-bold text-gray-800 mb-4">
              ¡Oops! Algo salió mal
            </h1>
            <p className="text-gray-600 mb-6">
              Estamos trabajando para solucionarlo. Por favor, recarga la página.
            </p>
            <button
              onClick={() => window.location.reload()}
              className="bg-[#B49A56] text-white px-6 py-2 rounded-lg hover:bg-[#9c8448] transition-colors"
            >
              Recargar página
            </button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
